import {KTSVG} from "../../../../_metronic/helpers";
import {FC} from "react";

type Props = {
    setOpenModal: any
    action: any
}

const RequestModalHeader: FC<Props> = ({setOpenModal, action}) => {
    return (
        <div className='modal-header'>
            <h2 className='fw-bolder'>{action.name}</h2>
            <div
                className='btn btn-icon btn-sm btn-active-icon-primary'
                data-kt-users-modal-action='close'
                onClick={() => setOpenModal(false)}
                style={{cursor: 'pointer'}}
            >
                <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1'/>
            </div>
        </div>
    )
}

export {RequestModalHeader}
